import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { FC, ReactNode } from 'react';

const SectionSummaryContainer: FC<{
  children: ReactNode;
}> = ({ children }) => {
  return <div css={sectionContainerStyles}>{children}</div>;
};

export default SectionSummaryContainer;

const sectionContainerStyles = css({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: token('space.300'),
  '@media (max-width: 767px)': {
    gap: token('space.200'),
  },
});
